import * as React from 'react';
import { IgcSelectItemComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents an item in a select list.
 * @slot  - Renders the all content bar the prefix and suffix.
 * @slot prefix - Renders content before the main content area.
 * @slot suffix - Renders content after the main content area.
 * @csspart prefix - The prefix wrapper of the igc-select-item.
 * @csspart content - The main content wrapper of the igc-select-item.
 * @csspart suffix - The suffix wrapper of the igc-select-item.
 * @class
 */
export const IgrSelectItem = /* @__PURE__ */ createComponent({
  tagName: 'igc-select-item',
  displayName: 'IgrSelectItem',
  elementClass: Component,
  react: React,
});

export type IgrSelectItem = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSelectItemModule = Component;
